import { isEmpty, toTileCase } from '@fareye/utils'
import React, { Dispatch, SetStateAction } from 'react'
import { Flex, Span, Label, styled } from '@fareye/ui'
import { IKeyValue, IKeyValueObj } from '@fareye/types'
import { KPI_COLORS, useTranslation } from '@fareye/common'
import { stateColorOption, statusColorOption } from '@fareye/configs'
import { ISummaryFilter } from '../utility/types'
import { inTransitConstant } from '../config/constants'

const StatusStatistics = styled(Flex)`
  padding: 0 10px;
  flex-direction: column;
  align-items: center;
`
// Will move to config once color and text is decided
export const colorOption = {
  ...stateColorOption,
  ...statusColorOption
}

export const FilterTab: any = styled(Flex)`
  cursor: pointer;
  ${(props: any) =>
    props.isSelected && {
      borderBottom: ` 3px solid ${'#006491'}`
    }}
`

export const CardFilterContainer = styled('div')<{ itemCount: number }>`
  display: grid;
  grid-gap: 0.5em;
  grid-template-columns: ${({ itemCount }: any) =>
    `repeat(auto-fill, minmax(110px , 1fr))`};
  @media (max-width: 425px) {
    grid-template-columns: ${_ => `repeat(${Math.floor(390 / 80)}, 1fr)`};
  }
`

const SummaryFilter = ({
  summaryData = {},
  selectedSummaryFilter,
  setSelectedSummaryFilter,
  singleSelect = false
}: ISummaryFilter) => {
  const { t } = useTranslation()
  const data = Object.values(summaryData)[0]
  let itemCount = !isEmpty(data) ? data.length : 0
  itemCount += 1
  const dataLength = data?.aggregations?.reduce((a: number, b: any) => a + b.count, 0)

  const handleChange = (key: string, value: string) => {
    if (selectedSummaryFilter.selectedFilters[key]?.includes(value)) {
      // unselecting the filter
      setSelectedSummaryFilter((oldSummaryFilter: any) => {
        return {
          ...oldSummaryFilter,
          numberOfFiltersApplied: oldSummaryFilter.numberOfFiltersApplied - 1,
          selectedFilters: {
            ...oldSummaryFilter.selectedFilters,
            [key]: oldSummaryFilter.selectedFilters[key].filter(
              (selectedValue: string) => selectedValue !== value
            )
          }
        }
      })
    } else if (singleSelect) {
      setSelectedSummaryFilter(() => ({
        numberOfFiltersApplied: 1,
        selectedFilters: { [key]: [value] }
      }))
    } else {
      // selecting the filter
      setSelectedSummaryFilter((oldSummaryFilter: any) => {
        if (Object.keys(oldSummaryFilter.selectedFilters).includes(key)) {
          return {
            ...oldSummaryFilter,
            numberOfFiltersApplied: oldSummaryFilter.numberOfFiltersApplied + 1,
            selectedFilters: {
              ...oldSummaryFilter.selectedFilters,
              [key]: [...oldSummaryFilter.selectedFilters[key], value]
            }
          }
        } else {
          return {
            ...oldSummaryFilter,
            numberOfFiltersApplied: oldSummaryFilter.numberOfFiltersApplied + 1,
            selectedFilters: {
              ...oldSummaryFilter.selectedFilters,
              [key]: [value]
            }
          }
        }
      })
    }
  }
  return (
    <CardFilterContainer itemCount={itemCount}>
      <FilterTab
        column
        p={2}
        id="all"
        key="all"
        isSelected={selectedSummaryFilter.numberOfFiltersApplied === 0}
        onClick={(ev: any) => {
          setSelectedSummaryFilter({
            ...selectedSummaryFilter,
            numberOfFiltersApplied: 0,
            selectedFilters: {}
          })
        }}
      >
        <Label
          color={KPI_COLORS['default']}
          style={{ textAlign: 'center', fontSize: '18px' }}
        >
          {dataLength}
        </Label>
        <Span style={{ textAlign: 'center' }} color={KPI_COLORS['default']}>
          {t(inTransitConstant['all'])}
        </Span>
      </FilterTab>
      {Object.keys(summaryData).map((item: string) => {
        const data = summaryData[item].aggregations
        return (
          <React.Fragment key={item}>
            {data &&
              data.map(
                (
                  { label, value, key, count, prettyName }: any,
                  index: number
                ) =>
                  key !== '' && (
                    <FilterTab
                      column
                      key={`${value}-${index}`}
                      p={2}
                      id={value}
                      isSelected={
                        !!selectedSummaryFilter.selectedFilters[key]?.includes(
                          value
                        )
                      }
                      onClick={(ev: any) => {
                        handleChange(key, value)
                      }}
                    >
                      <Label
                        color={(KPI_COLORS as any)[value]}
                        style={{ textAlign: 'center', fontSize: '18px' }}
                      >
                        {count}
                      </Label>
                      <Span
                        style={{ textAlign: 'center' }}
                        color={KPI_COLORS['default']}
                      >
                        {t(toTileCase(label))}
                      </Span>
                    </FilterTab>
                  )
              )}
          </React.Fragment>
        )
      })}
    </CardFilterContainer>
  )
}

export default SummaryFilter
